export default {
  getError(state) {
    return { error: state.error, errorMessage: state.errorMessage };
  },
  getLoggedAccount(state) {
    return state.account;
  },
};
